import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import PageWrapper from './PageWrapper';
import EditableText from './EditableText';
import MatrixVisualization from '../../Feedback360ResultsPage/children/MatrixVisualization/MatrixVisualization';
import { FEEDBACK_360_SURVEY } from '../../../../config/questionTypeConstants';

const MATRIX_FRAME_WIDTH = 674;
const MATRIX_FRAME_HEIGHT = 720;
const MATRIX_INNER_WIDTH = 1100;

export default function TwoByTwoMatrixPage({ data, personName, pageNumber, reportType = 'standard' }) {
  const innerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    if (!innerRef.current) return;
    const { scrollWidth, scrollHeight } = innerRef.current;
    if (!scrollWidth || !scrollHeight) return;
    const fitScale = Math.min(
      MATRIX_FRAME_WIDTH / scrollWidth,
      MATRIX_FRAME_HEIGHT / scrollHeight,
      1
    );
    setScale(fitScale);
  }, [data]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.__matrixReady = true;
      }
    }, 400);
    return () => clearTimeout(t);
  }, [scale]);

  return (
    <PageWrapper pageNumber={pageNumber} personName={personName}>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        {/* Trend report inserts Key Trends as section 6, shifting this to 7. */}
        <span className="pdf-section-heading__badge">{reportType === 'trend' ? 7 : 6}</span>
        <EditableText
          as="span"
          path="twoByTwoMatrix.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="p"
        className="pdf-body-text"
        path="twoByTwoMatrix.twoByTwoContent"
        variant="block"
        stripInlineWrap
      />
      <EditableText
        as="div"
        className="pdf-bullet-list"
        path="twoByTwoMatrix.twoByTwoBullets"
        variant="block"
      />

      <div className="pdf-matrix-frame" data-matrix-target>
        <div
          ref={innerRef}
          className="pdf-matrix-frame__inner"
          style={{
            width: `${MATRIX_INNER_WIDTH}px`,
            transform: `scale(${scale})`,
          }}
        >
          <MatrixVisualization
            isForPdfGeneration={true}
            projectType={FEEDBACK_360_SURVEY.DYNAMIC_360_FEEDBACK_ARCTERYX}
            fetchMatrixVisualizationApi={{
              isProcessing: false,
              error: null,
              data: data.content,
              isDataFetched: true,
            }}
          />
        </div>
      </div>
    </PageWrapper>
  );
}
